import InformationIcon from '../../assets/icons/banco-de-chile/InformationIcon';
import ConfirmationIcon from '../../assets/icons/banco-de-chile/ConfirmationIcon';

const branding = {
  icons: {
    information: InformationIcon,
    confirmation: ConfirmationIcon,
  },
};

export default branding;
